import {React, observer, observable, classNames, useCallback, Suspense, toHeaderCase} from '@api'
import {BorderNode, FlexLayout, TabNode} from '@flexlayout'
import {} from '@blueprintjs/core'
import {IFlexLayoutTabProps} from '@stores'
import {useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {IFlexLayoutCatalogRootConfig, LayoutPreviewPanel} from '@stores/catalog/flexLayout'
import * as css from './FlexLayoutPreview.css'

/// region Store

export class CatalogFlexLayoutPreviewStore extends VipLocalStore{
  constructor(s) {
    super(s)
  }

  @observable mustHaveAtLeastOneObservable = true
}

export const FlexLayoutPreviewStoreContext = React.createContext<CatalogFlexLayoutPreviewStore>(null)
export const useFlexLayoutPreviewStore = () => React.useContext(FlexLayoutPreviewStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const FlexLayoutPreview = observer<MyProps>(function CatalogFlexLayoutPreview({className, ...props}) {
  const store = useVipLocalStore((s) => new CatalogFlexLayoutPreviewStore(s))
  const {
       flexLayout: {isMaximized, setPreviewLayoutRef, onPreviewModelChange, previewLayoutInteractionNode, model, previewModel, showLayoutPreview, onRenderTab, onRenderTabSet, onAction, iconFactory},
    workspaces: {wrapperById}
    } = useStores(),
    renderNamedComponent = useCallback((previewTabNode: TabNode): React.ReactNode => {
      if (!previewTabNode) return null

      const realNode = model.nodeById<TabNode>(previewTabNode.id) || previewTabNode,
        {attributes: {component}} = previewTabNode,
        config = realNode.config as IFlexLayoutCatalogRootConfig,
        {catalogRoot} = realNode,
        props: IFlexLayoutTabProps = {
          ..._.pick(config, ['workspace', 'deployment']),
          flexNode: previewTabNode
        }

      let instance
      switch (component) {
        default:
          const labelNode = catalogRoot?.tab ?? realNode
          let label = `${labelNode.displayName ?? (realNode.name ? realNode.name : (config?.settings?.workspace ? `${wrapperById[config.settings.workspace]?.config?.title ?? realNode.displayName}` : toHeaderCase(realNode.component)))}`

         // catalogRoot && (label += `\n(${toHeaderCase(catalogRoot.catalog.settings.viewMode)})`)
          instance = <LayoutPreviewPanel label={label} />
          //${config?.workspace ? `${wrapperById[config?.workspace]?.config?.title ?? node.displayName}` : toHeaderCase(node.component)}`
          break
      }

      return <Suspense fallback={null}>
        {instance}
      </Suspense>
    }, [])

  if (!model || isMaximized) return null

  const leftBorder = model.borderSet.borders.find(b => b.location.name === 'left') as BorderNode,
    showingTab = !leftBorder ? false : _.isNumber(leftBorder.json.selected) && leftBorder.json.show !== false
  
  let leftBorderSize = 0
  if (leftBorder) {
    const {borderBarSize, size, model: {splitterSize}} = leftBorder
    leftBorderSize = borderBarSize + (!showingTab ? 0 : (size + splitterSize))
  }

  return (
    <FlexLayoutPreviewStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}
           style={{'--left-border-width': `${leftBorderSize}px`} as any}
           data-interaction-preview={previewLayoutInteractionNode != null}
           data-visible={showLayoutPreview}>
        {previewModel && <FlexLayout.Layout
          ref={setPreviewLayoutRef}
          model={previewModel}
          factory={renderNamedComponent}
          onRenderTab={onRenderTab}
          onRenderTabSet={onRenderTabSet}
          onAction={onAction}
          iconFactory={iconFactory}
          onModelChange={onPreviewModelChange}
        />}
      </div>
    </FlexLayoutPreviewStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/FlexLayoutPreview.tsx